import ActivityPage from './ActivityPage';

export default ActivityPage;
